/*
 * Product template - Autoplay videos.
 */

  (function() {
    function setupVideo(video) {
      return;

      video.setAttribute('muted', '');
      video.defaultMuted = true;
      video.muted = true;
      video.autoplay = true;
      video.setAttribute('preload', 'auto');
      video.preload = 'auto';
      video.load();
      video.play().catch(function() {});

      // Hide the poster overlay to reveal the playing video
      var poster = video.closest('.product-media--video').querySelector('.product-media__poster');
      if (poster) {
        poster.classList.add('product-media__poster--hide');
      }
    }

    function pauseVideo(video) {
      video.pause();
    }

    // Autoplay the active video on page load
    function autoplayOnLoad() {
      document.querySelectorAll('.product-media--video video').forEach(function(video) {
        if (video.closest('.slide--inactive-option')) return;
        setupVideo(video);
      });
    }

    if (document.readyState === 'complete') {
      setTimeout(autoplayOnLoad, 500);
    } else {
      window.addEventListener('load', function() {
        setTimeout(autoplayOnLoad, 500);
      });
    }

    // Autoplay the correct video when a colour swatch is clicked
    document.querySelectorAll('.option-selector--swatch input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', function(e) {
        var selectedColor = e.target.value;

        setTimeout(function() {
          // Pause all product videos
          document.querySelectorAll('.product-media--video video').forEach(function(video) {
            pauseVideo(video);
          });

          // Find and autoplay the video matching the selected colour
          var targetSlide = document.querySelector('.slide[data-variant-image-group="' + selectedColor + '"] video');
          if (targetSlide) {
            setupVideo(targetSlide);
          }
        }, 300);
      });
    });

    // MutationObserver for any dynamically added videos
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var videos = node.tagName === 'VIDEO' ? [node] : node.querySelectorAll ? Array.from(node.querySelectorAll('video')) : [];
            videos.forEach(function(video) {
              if (video.closest('.slide--inactive-option')) return;
              setupVideo(video);
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();

/*
 * Collection page - Category filter buttons above product grid.
 * Toggles the matching checkbox in the hidden filter form then triggers
 * an immediate AJAX load via the theme's link-click handler (which,
 * unlike the form change/submit handler, is not debounced).
 */
(function() {
  function buildFilterUrl(form) {
    var queryVals = [];
    form.querySelectorAll('input, select').forEach(function(input) {
      if (
        (input.type !== 'checkbox' && input.type !== 'radio' || input.checked) &&
        input.value !== ''
      ) {
        queryVals.push(input.name + '=' + encodeURIComponent(input.value));
      }
    });
    var url = location.pathname;
    if (queryVals.length) {
      url += '?' + queryVals.join('&');
    }
    return url;
  }

  function triggerAjaxLoad(form) {
    var url = buildFilterUrl(form);
    var container = form.closest('[data-section-type="collection-template"]');
    if (!container) return;
    var link = document.createElement('a');
    link.href = url;
    link.className = 'filter-group__clear-link';
    link.style.display = 'none';
    container.appendChild(link);
    link.click();
    link.remove();
  }

  document.addEventListener('click', function(e) {
    var allBtn = e.target.closest('[data-category-all]');
    var catBtn = e.target.closest('[data-category-btn]');

    if (allBtn) {
      var form = document.getElementById('CollectionFilterForm');
      if (!form) return;
      var paramName = allBtn.getAttribute('data-category-param');
      form.querySelectorAll('input[name="' + paramName + '"]').forEach(function(cb) {
        cb.checked = false;
      });
      triggerAjaxLoad(form);
      return;
    }

    if (catBtn) {
      if (catBtn.disabled) return;
      var form = document.getElementById('CollectionFilterForm');
      if (!form) return;
      var filterName = catBtn.getAttribute('data-filter-name');
      var filterValue = catBtn.getAttribute('data-filter-value');
      var checkbox = form.querySelector('input[name="' + filterName + '"][value="' + filterValue + '"]');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        triggerAjaxLoad(form);
      }
    }
  });
})();
/*
 * Collection template - SEO content read-more toggle.
 */

(function() {
  document.addEventListener('click', function(e) {
    var readMore = e.target.closest('[data-seo-read-more]');
    var showLess = e.target.closest('[data-seo-show-less]');
    if (!readMore && !showLess) return;
    e.preventDefault();
    var container = (readMore || showLess).closest('.rte');
    if (!container) return;
    var content = container.querySelector('[data-seo-read-more-content]');
    var readMoreLink = container.querySelector('[data-seo-read-more]');
    var showLessWrap = container.querySelector('[data-seo-show-less-wrap]');
    if (!content || !readMoreLink) return;
    var expanded = !!readMore;
    content.hidden = !expanded;
    if (showLessWrap) showLessWrap.hidden = !expanded;
    readMoreLink.parentElement.hidden = expanded;
    readMoreLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
})();
